// src/reducers/searchSlice.js
import { createSlice } from '@reduxjs/toolkit';

const searchSlice = createSlice({
    name: 'search',
    initialState: {
        query: '', // This ensures `query` is defined in the initial state
        isSearched: false,
    },
    reducers: {
        setSearchQuery: (state, action) => {
            state.query = action.payload;
        },
        setIsSearched: (state, action) => {
            state.isSearched = action.payload;
        },
    },
});



export const { setSearchQuery, setIsSearched } = searchSlice.actions;
export default searchSlice.reducer;

